module.exports = __webpack_public_path__ + "06_medium_brown.963f28e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/06_medium_brown.png
// module id = Ayoo
// module chunks = 0